declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: (...args: any[]) => void
  }
}

const PIXEL_ID = '1131669893352592'

let initialized = false

function loadPixelScript() {
  if (initialized) return
  initialized = true

  const f = window as any
  const b = document

  if (f.fbq) return

  const n: any = (f.fbq = function (...args: any[]) {
    if (n.callMethod) {
      n.callMethod.apply(n, args)
    } else {
      n.queue.push(args)
    }
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = b.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const s = b.getElementsByTagName('script')[0]
  if (s && s.parentNode) {
    s.parentNode.insertBefore(t, s)
  } else {
    b.head.appendChild(t)
  }

  window.fbq('init', PIXEL_ID)
}

export function trackPageView() {
  loadPixelScript()
  window.fbq('track', 'PageView')
}

export function trackAddToCart() {
  loadPixelScript()
  window.fbq('track', 'AddToCart', {
    content_name: 'Cuna de Hierro',
    content_type: 'product',
    value: 6.39,
    currency: 'USD',
  })
}
